<p-table
  #table
  [value]="salesArray"
  [responsive]="true"
  *ngIf="salesArray.length != 0"
  dataKey="id"
  responsiveLayout="stack"
  [breakpoint]="'960px'"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th [pSortableColumn]="'datetime'">Date</th>
      <th [pSortableColumn]="'uuid'">Sale ID</th>
      <th [pSortableColumn]="'cachedClientsFromServer'">Client</th>
      <!-- <th [pSortableColumn]="'tipsTotal'">Tips</th> -->
      <th [pSortableColumn]="'cachedTotalsFromServer'">Total</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-saleArray>
    <tr tappable (click)="navigate(saleArray)">
      <td>
        <span class="p-column-title"><b>Date</b></span>
        {{ saleArray["datetime"] | salonMonsterDate : "MMM D, Y @ h:mm a" }}
      </td>
      <td>
        <span class="p-column-title"><b>Sale ID</b></span>
        {{ saleArray["uuid"] }}
      </td>
      <td>
        <span class="p-column-title"><b>Client</b></span>
        {{ saleArray["cachedClientsFromServer"] }}
      </td>
      <!-- <td>
        <span class="p-column-title"><b>Tips</b></span>
        {{ saleArray["tipsTotal"] | salonMonsterCurrency }}
      </td> -->
      <td>
        <span class="p-column-title"><b>Total</b></span>
        {{ saleArray["cachedTotalsFromServer"] | salonMonsterCurrency }}
      </td>
    </tr>
  </ng-template>

  <ngx-datatable-column
    name="Client"
    prop="cachedClientsFromServer"
    [flexGrow]="2"
  >
    <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
      <span>
        {{ row.cachedClientsFromServer }}
      </span>
    </ng-template>
  </ngx-datatable-column>
</p-table>
<div
  *ngIf="salesArray.length === 0"
  class="ion-padding ion-text-center smr-empty-state"
>
  <img src="./assets/images/no-sales.png" style="margin-top: 20px" />
  <h4>No sales to display:</h4>
  There were no sales in this date range. Either make a sale or view a different
  date range.
</div>
